import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=e3e0465a&"
import script from "./SettingsModal.vue?vue&type=script&lang=js&"
export * from "./SettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3e0465a')) {
      api.createRecord('e3e0465a', component.options)
    } else {
      api.reload('e3e0465a', component.options)
    }
    module.hot.accept("./SettingsModal.vue?vue&type=template&id=e3e0465a&", function () {
      api.rerender('e3e0465a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/rentalBookings/components/SettingsModal.vue"
export default component.exports